<template>
  <span
    :class="[
      bemBlockMod({
        detail: type == 'detail',
        'detail-primary': type == 'detail' && subtype == 'primary',
        'detail-secondary': type == 'detail' && subtype == 'secondary',
        grid: type == 'grid',
        'grid-primary': type == 'grid' && subtype == 'primary',
        'grid-secondary': type == 'grid' && subtype == 'secondary',
        uppercase:
          !isCustom &&
          (type == 'grid' || (type == 'detail' && subtype == 'primary')),
      }),
      'tag',
      'tag-vue',
    ]"
    :style="textColor ? tagStyles : ''"
  >
    {{ text }}
  </span>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';

export default {
  name: 'BaseTag',

  mixins: [bemClassesMixin],

  props: {
    type: {
      type: String,
      validator: (prop) => ['detail', 'grid'].includes(prop),
      required: true,
    },
    subtype: {
      type: String,
      validator: (prop) => ['primary', 'secondary'].includes(prop),
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    textColor: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    isCustom: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    tagStyles() {
      return {
        color: this.textColor,
      };
    },
  },
};
</script>
